// Single source for the phone number and WhatsApp message text.
// Digits only, with country code, no "+" (wa.me format).
export const WHATSAPP_NUMBER = '628991982131';

export const defaultMessage =
  'Hi Timothy! I saw your portfolio and would like to discuss a project.';

export const quickMessages = [
  'Hi! I’m interested in your services',
  'Let’s discuss a project',
  'I’d like to hire you',
  'Tell me more about your work',
];

export function buildWhatsAppLink(text) {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
}
